import { TranslateFunc } from "./translation.utils";
import { GroupType } from "../domain/group/group-type";

export const getGroupTypeTranslation = (type: GroupType, t: TranslateFunc) => {
  const groupTypeKey = GroupType[type]?.replace(/([a-z])([A-Z])/g, "$1_$2");
  const id = `basedata.users.table.group.${groupTypeKey}`.toLowerCase();
  return t(id);
};

export const getGroupTypeTranslationForLabel = (type: GroupType, t: TranslateFunc) => {
  const id = getGroupTypeTranslation(type, t);
  return `${t("basedata.group.groupType")}: ${t(id)}`;
};
